import * as React from "react";

function UserSettingsPage() {
  return <h1>User Settings Page</h1>;
}

export default UserSettingsPage;
